import React from "react";
import { Link, useLocation } from "react-router-dom";

import { hasPermission } from "../../services/auth";

// "Cadastros e ajustes" do módulo Gestão: três telas que antes moravam em
// Financeiro › Cadastros, Configurações › Fiscal e Configurações › Automações.
export const GESTAO_SETTINGS_TABS = [
    { name: 'Cadastros', to: '/finance/settings', permission: 'manage_finance' },
    { name: 'Fiscal', to: '/fiscal/settings', permission: ['view_fiscal', 'manage_fiscal'], matches: ['/fiscal/operations'] },
    { name: 'Automações', to: '/finance/automations', permission: ['view_finance', 'manage_finance'] },
];

const visibleTabs = () => GESTAO_SETTINGS_TABS.filter(tab => hasPermission(tab.permission));

export const firstGestaoSettingsPath = () => visibleTabs()[0]?.to ?? null;

export const GestaoSettingsTabs = () => {
    const { pathname } = useLocation();
    const tabs = visibleTabs();
    const isActive = tab => [tab.to, ...(tab.matches ?? [])].some(path => pathname === path || pathname.startsWith(path + '/'));

    return (
        <div className="gestao-settings-header">
            <p className="gestao-settings-crumb">Gestão</p>
            <h1 className="gestao-settings-title">Cadastros e ajustes</h1>
            {tabs.length > 1 &&
                <nav className="gestao-settings-tabs" aria-label="Cadastros e ajustes">
                    {tabs.map(tab => (
                        <Link
                            key={tab.to}
                            to={tab.to}
                            className={isActive(tab) ? 'active' : ''}
                            aria-current={isActive(tab) ? 'page' : undefined}
                        >
                            {tab.name}
                        </Link>
                    ))}
                </nav>
            }
        </div>
    );
};

export default GestaoSettingsTabs;
